import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatCardModule, MatCheckboxModule, MatDialogModule, MatDividerModule, MatExpansionModule, MatFormFieldModule, MatGridListModule, MatIconModule, MatInputModule, MatRadioModule, MatSidenavModule, MatStepperModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ValidarComponent } from './components/validar/validar.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { CuestionarioComponent } from './components/cuestionario/cuestionario.component';
import { ParesDialogComponent } from './components/par/pares-dialog/pares-dialog.component';
import { ReporteDialogComponent } from './components/par/reporte-dialog/reporte-dialog.component';
import { DocenteParComponent } from './components/docente-par/docente-par.component';
import { ParComponent } from './components/par/par.component';
import { AsignarComponent } from './components/par/asignar/asignar.component';
import { SeleccionComponent } from './components/par/seleccion/seleccion.component';
import { EvaluarComponent } from './components/par/evaluar/evaluar.component';
import { EstudianteComponent } from './components/estudiante/estudiante.component';
import { EvaluadosComponent } from './components/evaluados/evaluados.component';
import { RespuestaEvaluadoComponent } from './components/respuesta-evaluado/respuesta-evaluado.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { InstructivoComponent } from './components/instructivo/instructivo.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ValidarComponent,
    DocenteParComponent,
    NavbarComponent,
    ParComponent,
    AsignarComponent,
    SeleccionComponent,
    EvaluarComponent,
    ReporteDialogComponent,
    ParesDialogComponent,
    CuestionarioComponent,
    EstudianteComponent,
    EvaluadosComponent,
    RespuestaEvaluadoComponent,
    NotFoundComponent,
    InstructivoComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    HttpClientModule,
    MatExpansionModule,
    MatGridListModule,
    MatDialogModule,
    MatStepperModule,
    MatRadioModule,
    MatTableModule,
    MatDividerModule,
    MatTooltipModule,
    MatTabsModule,
    MatCheckboxModule,
    MatSidenavModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    DatePipe,
    {
      provide: LocationStrategy, useClass: HashLocationStrategy
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [CuestionarioComponent, ReporteDialogComponent, ParesDialogComponent, EvaluadosComponent, RespuestaEvaluadoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
